const steps = [
  {
    id: "01",
    title: "Discover",
    copy: "A deep-dive workshop. We map business goals, constraints and the humans who will use what we build.",
  },
  {
    id: "02",
    title: "Architect",
    copy: "We draft the blueprint — information architecture, tech stack, hiring plan or conversation design.",
  },
  {
    id: "03",
    title: "Build",
    copy: "Weekly shippable increments. Tight Loom updates. No black-box agencies, no surprise invoices.",
  },
  {
    id: "04",
    title: "Operate",
    copy: "We stay beyond launch — observability, iteration, and ongoing talent or AI ops support.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
        <div className="md:col-span-5">
          <div className="font-mono-label mb-4">§ 02 — Process</div>
          <h2 className="font-display text-5xl md:text-7xl">
            How we
            <br />
            operate.
          </h2>
        </div>
        <p className="md:col-span-5 md:col-start-8 text-[color:var(--fis-ink-soft)] self-end">
          A pragmatic, linear process that keeps you close to the work. No fluff
          decks, no bloated SOWs — just a calendar of outcomes.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 border-t fis-hairline">
        {steps.map((s, i) => (
          <div
            key={s.id}
            data-testid={`process-step-${s.id}`}
            className={`py-10 md:py-14 md:px-8 ${
              i !== 0 ? "md:border-l fis-hairline" : ""
            }`}
          >
            <div className="font-mono-label text-[color:var(--fis-accent)]">
              Step {s.id}
            </div>
            <h3 className="font-display text-3xl mt-4">{s.title}</h3>
            <p className="mt-4 text-[color:var(--fis-ink-soft)] leading-relaxed">
              {s.copy}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
